import React, { useEffect } from 'react';
import {
  Switch,
  Route,
  useLocation
} from 'react-router-dom';

import './css/style.scss';

import AOS from 'aos';
import { focusHandling } from 'cruip-js-toolkit';

import Home from './pages/Home';
import Blog from './pages/Blog';
import BlogSearch from './pages/BlogSearch';
import BlogPost from './pages/BlogPost';
import About from './pages/About';
import Services from './pages/Services';
import SignIn from './pages/SignIn';
import SignUp from './pages/SignUp';
import ResetPassword from './pages/ResetPassword';
import PageNotFound from './pages/PageNotFound';

function App() {

  const location = useLocation();

  useEffect(() => {
    AOS.init({
      once: true,
      disable: 'phone',
      duration: 600,
      easing: 'ease-out-sine',
    });
  });

  useEffect(() => {
    document.querySelector('html').style.scrollBehavior = 'auto'
    window.scroll({ top: 0 })
    document.querySelector('html').style.scrollBehavior = ''
    focusHandling('outline');
  }, [location.pathname]); // triggered on route change

  return (
    <>
      <Switch>
        <Route exact path="/">
          <Home />
        </Route>
        {/* <Route path="/features">
          <Features />
        </Route>
        <Route path="/pricing">
          <Pricing />
        </Route>*/}
        <Route path="/blog/tag/:tag" component={BlogSearch}/>
        <Route path="/blog/by/:author" component={BlogSearch}/>
        <Route path="/blog/" component={Blog}/>
        <Route path="/blog-post/:index">
         <BlogPost/>
        </Route> 
        <Route path="/about">
          <About />
        </Route> 
        <Route path="/services">
          <Services />
        </Route> 
        {/* <Route path="/contact">
          <Contact />
        </Route> */}
        {/* <Route path="/help">
          <Help />
        </Route> */}
        <Route path="/signin">
          <SignIn />
        </Route>
        {/* <Route path="/signup">
          <SignUp />
        </Route> */}
        {/* <Route path="/reset-password">
          <ResetPassword />
        </Route> */}
        <Route path="*">
          <PageNotFound />
        </Route>
      </Switch>
    </>
  );
}

export default App;
